var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestionCircleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "question-circle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.618,
    height: 18.618,
    viewBox: "0 0 18.618 18.618",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_345",
    "data-name": "Group 345"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9330",
    "data-name": "Path 9330",
    d: "M9.309,17.455a8.145,8.145,0,1,1,8.145-8.145,8.145,8.145,0,0,1-8.145,8.145Zm0,1.164A9.309,9.309,0,1,0,0,9.309,9.309,9.309,0,0,0,9.309,18.618Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9331",
    "data-name": "Path 9331",
    d: "M15.765,13.16a.276.276,0,0,0,.28.287h.96a.324.324,0,0,0,.31-.291,1.454,1.454,0,0,1,1.562-1.32A1.352,1.352,0,0,1,20.405,13.2c0,.739-.435,1.079-1.123,1.6A2.65,2.65,0,0,0,17.923,17.1l0,.253a.291.291,0,0,0,.291.286h.944a.291.291,0,0,0,.291-.291v-.122c0-.835.318-1.079,1.175-1.729a2.84,2.84,0,0,0,1.448-2.392c0-1.758-1.485-2.608-3.11-2.608-1.474,0-3.089.687-3.2,2.66Zm1.812,6.706a1.19,1.19,0,1,0,1.174-1.094A1.1,1.1,0,0,0,17.576,19.866Z",
    transform: "translate(-9.65 -6.427)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircleIcon);
export default __webpack_public_path__ + "static/media/question-circle-icon.2b4b1e48594dfaaf9afdbab6d568984c.svg";
export { ForwardRef as ReactComponent };